<script>
	const _ = require('underscore');
	const moment = require('moment');
	const page = require('page');
	const model = require('model/model');
	const studentProgressUtilities = require('utilities/studentProgressUtilities');
	const utilities = require('utilities');
	const getWordCount = utilities.getWordCount;
	const Grading = require('readworks-grading');
	const logger = require('utilities/logger');

	let timeout = null;

	module.exports = {
		components: {
			'results-grid': require('components/results-grid.vue').default,
			'overdue-icon': require('components/overdue-icon.vue').default,
			'info-icon': require('components/svg/info-icon.vue').default
		},
		modelData: {
			classCode: 'classCode',
			studentId: 'studentId',
			assignmentTab: 'assignmentTab',
			studentProgressTab: 'studentProgressTab',
			studentProgressResults: 'rawResults',
			studentProgressMonth: 'studentProgressMonth',
			studentProgressMonthIndividual: 'month',
			individualStudentProgressExportData: 'ispExportData'
		},
		props: {
			currentClass: {
				required: true
			},
			monthList: {
				required: true
			},
			studentName: {
				required: true
			}
		},
		data: function () {
			return {
				statusGrid: studentProgressUtilities.grids[studentProgressUtilities.gridKeys.INDIVIDUAL_STUDENT_PROGRESS],
				showBBOKButton: false
			};
		},
		computed: {
			classResults: function () {
				let rawResults = this.rawResults;
				let classCode = this.classCode;
				let startDate = this.startDate;
				let endDate = this.endDate;

				if (!rawResults || !classCode || !startDate || !endDate) {
					return null;
				}
				return rawResults[classCode + startDate + endDate];
			},
			startDate: function () {
				let month = this.month;
				return studentProgressUtilities.getStartDate(month);
			},
			endDate: function () {
				let month = this.month;
				let endDate = studentProgressUtilities.getEndDate(month);
				let now = new Date().getTime();

				if (endDate > now) {
					endDate = now;
				}

				return endDate;
			},
			resultsData: function () {
				let studentId = this.studentId;
				let assignments = this.classResults;
				let classCode = this.classCode;
				let now = new Date().getTime() / 1000;

				this.showBBOKButton = false;

				if (!assignments || !studentId) {
					return [];
				}

				let data = [];

				assignments.forEach(r => {
					let workspaces = r.workspaces || [];
					let product = r.product;
					let assignmentId = r.aid;
					let startDate = r.d;
					let closed = r.closed;
					let title = product.title;
					let productType = product.pt;
					let productId = product.uuid;
					let submittedTimestamp = null;
					let resubmittedTimestamp = null;
					let studentActivity = null;
					let articlesRead = 0;
					let articleWords = 0;
					const bokAssigned = r.bok;
					let bokEntries = 0;
					let bokWordsWritten = 0;
					let wordsExplored = null;
					let readArticles = [];
					let questionSets = [];
					let overdue = false;
					let hasQuestionSets = false;
					let ended = false;
					let endDate = null;
					let statusText = '';
					const textSet = r.product.textSet;
					const subType = product.subType;

					const studentWorkspace = workspaces.find(({ uid }) => uid === studentId);
					const hasWorkspace = !!studentWorkspace;
					const isAssigned = (r.suids && (!Object.keys(r.suids).length || r.suids[studentId])) || (hasWorkspace && studentWorkspace.s === 's');

					if (isAssigned) {
						if (hasWorkspace) {
							submittedTimestamp = studentWorkspace.ts;

							let duedate = studentWorkspace.edd || r.edd;
							if (duedate) {
								overdue = duedate < (submittedTimestamp || now);
							}
						}

						if (r.qs && r.qs.length) {
							hasQuestionSets = true;
							r.qs.forEach(function (qs) {
								let currentSet = {
									title: product.questionSets[qs].title,
									abridged_question_ids: product.questionSets[qs].abridged_question_ids || [],
									graded: 0,
									correct: 0
								};
								let numberOfQuestions = product.questionSets[qs].numberOfQuestions;
								let isExpressQs = product.questionSets[qs].abridged_question_ids && _.contains(r.expressqs || [], qs);
								let expressQMap = {};

								if (isExpressQs) {
									numberOfQuestions = 0;
									expressQMap = currentSet.abridged_question_ids.reduce((acc, qid) => {
										acc[qid] = true;
										numberOfQuestions++;
										return acc;
									}, {});
								}

								if (studentWorkspace) {
									// Calc question set stats for P & A
									let workspaceSets = studentWorkspace.sc.q;
									let answeredSet = workspaceSets[qs];
									let gradeClosed = closed && (!studentWorkspace.edd || studentWorkspace.edd < closed);
									resubmittedTimestamp = studentWorkspace.rts;
									if (answeredSet && (studentWorkspace.s === 's' || gradeClosed)) {
										for (let questionKey in answeredSet) {
											let question = answeredSet[questionKey];
											if ((isExpressQs && expressQMap[questionKey]) || !isExpressQs) {
												if ('s' in question || Grading.questionTypeIsScorable(question.qt)) {
													currentSet.graded += 1;
													currentSet.correct += question.s || 0;
												}
											}
										}
									}
								} else if (closed) {
									currentSet.correct = 0;
									currentSet.graded = numberOfQuestions;
								}
								questionSets.push(_.assign({}, currentSet));
							});
						}

						// Calculate reading stats for AAD
						if (studentWorkspace && productType === 'AAD') {
							let workspaceArticles = studentWorkspace.sc.a;

							for (let article in workspaceArticles) {
								if (workspaceArticles[article] && workspaceArticles[article].s === 's') {
									readArticles.push(article);

									if (!bokAssigned) {
										continue;
									}

									if (!product.allArticles[article].decodable_teacher_edition) {
										bokEntries += 1;
									}

									if (workspaceArticles[article].b && workspaceArticles[article].b.length) {
										bokWordsWritten += getWordCount(workspaceArticles[article].b);
										if (workspaceArticles[article].brev && workspaceArticles[article].brev.length) {
											bokWordsWritten += getWordCount(workspaceArticles[article].brev);
										}
									}
								}
							}
							articlesRead = readArticles.length;
							readArticles.forEach(article => {
								articleWords += product.allArticles[article].wordcount || 0;
							});
						}

						if (r.graphicOrganizers) {
							wordsExplored = 0;
							r.graphicOrganizers.some(g => {
								if (g.uid === studentId) {
									wordsExplored = Object.keys(g.n).length - 1;
									return true;
								}
								return false;
							});
						}

						if (bokEntries) {
							this.showBBOKButton = true;
						}

						if (productType === 'AAD') {
							endDate = r.ed;
							if (studentWorkspace && studentWorkspace.edd) {
								endDate = studentWorkspace.edd;
							}
							if (endDate) {
								ended = endDate < now;
							}
						}

						if (submittedTimestamp && productType !== 'AAD') {
							statusText = resubmittedTimestamp ? 'Resubmitted' : 'Submitted';
						} else if (submittedTimestamp || closed || ended) {
							statusText = 'Ended';
						} else {
							statusText = hasWorkspace ? 'In Progress' : 'Not Started';
						}

						let record = {
							studentId,
							assignmentId,
							classCode,
							startDate,
							title,
							productType,
							productId,
							submittedTimestamp,
							resubmittedTimestamp,
							studentActivity,
							bokAssigned,
							bokEntries,
							bokWordsWritten,
							wordsExplored,
							articlesRead,
							articleWords,
							questionSets,
							hasWorkspace,
							overdue,
							hasQuestionSets,
							ended,
							endDate,
							closed,
							statusText,
							textSet,
							subType
						};

						data.push(record);
					}
				});

				data.sort((a, b) => b.startDate - a.startDate);

				return data;
			},
			exportData() {
				const results = this.resultsData;
				if (results.length === 0) {
					return undefined;
				}

				const monthList = this.monthList;
				let period = monthList.find(({ value }) => String(value) === String(this.month)).text;

				if (period === 'See All') {
					period = `${monthList[monthList.length - 2].text} - ${monthList[0].text}`;
				}

				const headers = [['Class', this.currentClass.name], ['Student', this.studentName], ['Time Period', period], [], []];

				const tableHeaders = this.statusGrid.columns.map(({ text }) => text);
				const qsHeaderRows = [['Reading Passages and Paired Texts'], tableHeaders];

				const aadHeaderRows = [['Article-A-Day'], tableHeaders.slice(0, -3).concat(['Results'])];

				const { aad, qs } = results.reduce(
					(acc, record) => {
						const { overdue, statusText, submittedTimestamp, endDate, productType } = record;

						const text = this.statusGrid.columns.map(column => {
							const { field } = column;
							if (field === 'status') {
								let overdueText = '';
								if (overdue) {
									overdueText = submittedTimestamp ? ' (Late)' : ' (Past Due)';
								}
								const date = submittedTimestamp || endDate;
								const dateString = date ? this.getDate(date) : '';
								return `${statusText}${overdueText} ${dateString}`;
							}

							let displayValue = this.getGridCellDisplayValue(record, column);

							displayValue = displayValue
								.replaceAll('<br />', ' ')
								.replace('Article-A-Day', '')
								.replaceAll('<div class="qset-separator"></div>', ' | ')
								.replaceAll('&nbsp;', ' ')
								.trim();

							if (field === 'correct' || field === 'percentage') {
								displayValue = displayValue.replaceAll('/', 'of');

								if (displayValue === '|') {
									displayValue = '';
								}
							}

							return utilities.stripHTMLFromString(displayValue);
						});

						if (productType === 'AAD') {
							acc.aad.push(text);
						} else {
							acc.qs.push(text);
						}

						return acc;
					},
					{
						aad: [...aadHeaderRows],
						qs: [...qsHeaderRows]
					}
				);

				return [...headers, ...qs, [], [], ...aad];
			}
		},
		watch: {
			studentProgressMonth: {
				handler(month) {
					if (month) {
						this.month = month;
					}
					if (!this.classResults) {
						this.fetchData();
					}
				},
				immediate: true
			}
		},
		methods: {
			getGridCellDisplayValue: function (record, col) {
				if (col.formatter) {
					return col.formatter.call(this, record[col.field], record, col);
				} else {
					return record[col.field];
				}
			},
			onGridCellClick: function (record, col) {
				if (col.field === 'title' && record.hasWorkspace) {
					model.set('studentProgressHash', {
						assignmentTab: this.assignmentTab,
						studentProgressTab: this.studentProgressTab,
						classCode: this.classCode,
						studentId: this.studentId
					});

					let baseUrl = `/assignment/${record.classCode}/${record.assignmentId}/class-results`;
					let hashState = {
						student: this.studentId
					};
					if (record.productType === 'AAD') {
						hashState = _.assign(hashState, {
							resultsTab: 'classresults',
							assessmentTab: 'bookofknowledge',
							bokResultsByStudent: record.productId
						});
					} else {
						hashState = _.assign(hashState, {
							assessmentTab: 'results',
							resultsTab: 'studentresults'
						});
					}
					page(baseUrl);
					model.set(hashState);
				}
			},
			getFlexValue: function (record, col) {
				if ((record.productType === 'AAD' || !record.hasQuestionSets) && col.field === 'studentActivity') {
					// first number is the sum of the flex values of the spanned columns
					// last number is 2px for the number of borders that are missing
					//  by spanning columns
					return '3.2 1 2px';
				}
				return col.flex || '1';
			},
			getDisplayValue: function (record, col) {
				if ((record.productType === 'AAD' || !record.hasQuestionSets) && (col.field === 'correct' || col.field === 'percentage')) {
					return 'none';
				}
				return 'block';
			},
			fetchData: function () {
				let classCode = this.classCode;
				let startDate = this.startDate;
				let endDate = this.endDate;

				if (timeout) {
					clearTimeout(timeout);
				}

				timeout = setTimeout(() => {
					studentProgressUtilities
						.fetchStudentProgressResults(classCode, startDate, endDate)
						.then(() => {
							this.ispExportData = this.exportData;
						})
						.fail(msg => logger.error(msg));
				}, 20);
			},
			getDate: function (ts) {
				return moment(ts * 1000).format('MMM D');
			}
		},
		mounted() {
			if (this.studentId && this.classCode && !this.classResults) {
				this.fetchData();
			}
			model.remove('studentProgressHash');
			if (this.studentProgressMonth) {
				this.month = this.studentProgressMonth;
			} else {
				this.month = this.month || this.currentMonth;
			}
		},
		beforeCreate() {
			// Attached in init because it doesn't need to be reactive
			this.currentMonth = studentProgressUtilities.getCurrentMonth();
		}
	};
</script>
<style lang="scss">
	@import 'mixins/flexbox';
	@import 'config/colors';

	.main.individual-student-progress {
		.table.results {
			width: 100%;

			.input-select {
				margin-bottom: 0rem;
				margin-left: 1rem;
				min-width: 7.5rem;
			}

			.qset-separator {
				border-top: 1px solid $c-grey;
				margin: 0.5rem -0.5rem;
			}

			.link-cell {
				cursor: auto;

				span.product-title {
					&.has-workspace {
						color: $c-blue-dark;
						cursor: pointer;

						&:hover {
							text-decoration: underline;
						}
					}
				}
			}

			img.small-icon {
				margin-left: 0.5rem;
			}
		}
	}
</style>
<template>
	<main class="main individual-student-progress form">
		<results-grid
			v-if="studentId"
			class="status-grid"
			:columns="statusGrid.columns"
			:data="resultsData">
			<!-- template slot to add month picker -->
			<template slot="thead">
				<div class="tr thead">
					<div
						class="cell"
						v-for="col in statusGrid.columns"
						:key="col.field"
						:style="{ flex: col.flex }"
						:class="[col.textAlign ? col.textAlign + '-text' : '']">
						<div class="cell-wrapper">
							<span v-html="col.text"></span>
							<button
								v-if="col.field === 'correct'"
								class="button -link print-hidden"
								v-tooltip="'This includes results for all multiple choice and any graded written response questions.'">
								<info-icon class="small-icon"></info-icon>
							</button>
						</div>
					</div>
				</div>
			</template>
			<template slot="tbody">
				<div
					class="tr"
					v-for="record in resultsData"
					:key="record.assignmentId">
					<div
						class="cell"
						v-for="col in statusGrid.columns"
						:key="col.field"
						:class="[col.textAlign ? col.textAlign + '-text' : '']"
						:style="{
							flex: getFlexValue(record, col),
							display: getDisplayValue(record, col)
						}">
						<a
							v-if="col.field === 'title' && record.hasWorkspace"
							:href="`/assignment/${record.classCode}/${record.assignmentId}/class-results`"
							class="cell-wrapper link-wrapper print-visible"
							@click.prevent="onGridCellClick(record, col)"
							v-html="getGridCellDisplayValue(record, col)">
						</a>
						<div
							v-else-if="col.field !== 'status'"
							class="cell-wrapper"
							v-html="getGridCellDisplayValue(record, col)"></div>
						<div
							v-else
							class="cell-wrapper">
							<div>
								{{ record.statusText }}
								<overdue-icon v-if="record.overdue"> </overdue-icon>
							</div>
							<div v-if="record.submittedTimestamp || record.endDate">{{ getDate(record.submittedTimestamp || record.endDate) }}</div>
						</div>
					</div>
				</div>
			</template>
		</results-grid>
	</main>
</template>
